import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/k_winnInvoice/invoiceControllers";

import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
        const formData = new FormData(e.target);
        setIsLoading(true);
        const option = {
          condition : { 
            ...(formData.get('invoice_date')      && {invoice_date : formData.get('invoice_date')}),
            ...(formData.get('users_name')        && {users_name : { $regex: formData.get('users_name'), $options: "i" }}),
            ...(formData.get('store')             && {store : { $regex: formData.get('store'), $options: "i" }}),
            ...(formData.get('area')              && {area : { $regex: formData.get('area'), $options: "i" }}),
            ...(formData.get('sales_person_name') && {sales_person_name : { $regex: formData.get('sales_person_name'), $options: "i" }}),
            ...(formData.get('users_mobile')      && {users_mobile : parseInt(formData.get('users_mobile'))}),
            ...(formData.get('total_due')         && {total_due : parseInt(formData.get('total_due'))}),
            ...(formData.get('batch_no')          && {batch_no : parseInt(formData.get('batch_no'))}),
            // createdAt : {$gte : `${filter?.from_date} ${filter?.from_time}`, $lte : `${filter?.to_date} ${filter?.to_time}` }
           },
           select : {},
           sort : {_id : -1}
        }
        const res = await list(option);
        if(res.status === true && res.result?.length > 0){
          let modifiedData = res?.result.map((items, index) => ({
              "Sl. No"                : index + 1,
              "STORE NAME"            : items?.store,
              "Invoice NO"            : items?.invoice_no,
              "POS NO"                : items?.pos_number,
              "BIND WITH"             : items?.sales_person_name,
              "DURATION"              : ` ${moment(items?.start_date).format("DD-MM-YYYY")} ${moment(`2025-03-03 ${items?.start_time}`).format('HH:mm')} to ${moment(items?.end_date).format("DD-MM-YYYY")} ${moment(`2025-03-03 ${items?.end_time}`).format('HH:mm')}
                                        `,
              "DAILY DRAW SALES"      : items?.lottoTotalSales,
              "DAILY DRAW COMMISSION" : items?.lottoTotalCommission,
              "DAILY DRAW REDEEM"     : items?.lottoPaidAmount,

              // "RAFFLE SALES"          : items?.raffleTotalSales,
              // "RAFFLE COMMISSION"     : items?.raffleTotalCommission,
              // "RAFFLE REDEEM"         : items?.rafflePaidAmount,

              "U-POINTS SALES"        : items?.rechargeTotalSales,
              "U-POINTS COMMISSION"   : items?.rechargeTotalCommission,
              "U-POINTS REDEEM"       : items?.rechargePaidAmount,
              // "REDEEM COMMISSION"     : items?.pointsRedeemCommission,

              // "REFERRAL BONUS"        : items?.pointsIncentives,

              "OLD DUE"               : items?.old_pending_balance || 0,
              "OTHER CHARGES"         : items?.other_charges || 0,
              "TOTAL DUE"             : (items?.sub_total_due || 0),
              "CREATED AT"            : moment(items?.createdAt).format('YYY-MM-DD HH:mm')
            }));
            if(modifiedData && modifiedData?.length >0){
              await exportToExcel(modifiedData);
            }
            handleCancel();
        } else{
          notification.open({
            message: "Oops!",
            description: `Zero records found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
    } catch (error) {
      setIsLoading(false);
    } finally {
        setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `Invoice Summary ${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export invoice
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="invoice_date" className="all_lable_for_vendor_dashbaord" > Invoice Date : </label>
                      <input type="date" name="invoice_date" id="invoice_date"class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="batch_no" className="all_lable_for_vendor_dashbaord" > Batch No. : </label>
                      <input type="number" name="batch_no" id="batch_no"class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_name" className="all_lable_for_vendor_dashbaord" > Name : </label>
                      <input type="text" name="users_name" id="users_name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="store" className="all_lable_for_vendor_dashbaord" > Store Name : </label>
                      <input type="text" name="store" id="store" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="area" className="all_lable_for_vendor_dashbaord" > Area : </label>
                      <input type="text" name="area" id="area" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_mobile" className="all_lable_for_vendor_dashbaord" > Mobile : </label>
                      <input type="number" name="users_mobile" id="users_mobile" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="pos_number" className="all_lable_for_vendor_dashbaord" > POS Number : </label>
                      <input type="number" name="pos_number" id="pos_number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="total_due" className="all_lable_for_vendor_dashbaord" > Due Amount : </label>
                      <input type="number" name="total_due" id="total_due" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="sales_person_name" className="all_lable_for_vendor_dashbaord" > Sales Person Name : </label>
                      <input type="text" name="sales_person_name" id="sales_person_name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
